import { render } from "./PageLoader.vue?vue&type=template&id=4f523ac9&scoped=true"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=4f523ac9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f523ac9"]])

export default __exports__